/* 创建计划 */
<template>
  <div id="orderPlanCreate" class="q-pa-md">
    <PageHeader content="创建计划" />
    <el-row class="rightBtn">
      <el-button @click="toDelivery" type="primary">查看送货单</el-button>
      <el-button @click="createDelivery" type="danger">开送货单</el-button>
    </el-row>
    <el-form ref="form" :model="form" label-width="100px">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="客户">
            <el-input v-model="form.customerShortName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单编号">
            <el-input v-model="form.orderNo" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="胚纱类型">
            <el-input v-model="form.yarnTypeName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="类型">
            <el-input v-model="form.roundType" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="是否并线">
            <el-select
              v-model="form.combine"
              placeholder="请选择是否并线"
              style="width: 100%"
              disabled
            >
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单日期">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="form.orderDate"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              disabled
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="期望交期">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="form.deliveryDate"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              disabled
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="客户备注">
        <el-input
          type="textarea"
          v-model="form.customerRemark"
          :autosize="{ minRows: 4, maxRows: 10 }"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单明细">
        <el-table
          :data="form.orderItems"
          style="width: 100%"
          border
          show-summary
        >
          <el-table-column prop="itemNo" label="订单项目编号"></el-table-column>
          <el-table-column label="纱支" prop="yarn"></el-table-column>
          <el-table-column label="颜色" prop="color" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.combine == '是'"
                >{{ scope.row.color }}*{{ scope.row.combineColor }}</span
              >
              <span v-else>{{ scope.row.color }}</span>
            </template>
          </el-table-column>
          <el-table-column label="色号" width="160">
            <template slot-scope="scope">
              <span v-if="scope.row.combine == '是'"
                >{{ scope.row.colorNo }}*{{ scope.row.combineColorNo }}</span
              >
              <span v-else>{{ scope.row.colorNo }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="参考缸号"
            prop="demand"
            width="120"
          ></el-table-column>
          <el-table-column
            label="订单数量(KG)"
            prop="itemQuantity"
            width="120"
          ></el-table-column>
          <el-table-column
            label="投产数量(KG)"
            prop="productQuantity"
            width="120"
          ></el-table-column>
          <el-table-column label="加工" prop="process"></el-table-column>
          <!-- <el-table-column label="单价" width="90" prop="price"></el-table-column> -->
          <!-- <el-table-column label="计价方式" width="100" prop="chargeMode"></el-table-column> -->
          <!-- <el-table-column label="加工费" width="100" prop="processFee"></el-table-column> -->
          <el-table-column
            label="期望交期"
            width="150"
            prop="deliveryDate"
          ></el-table-column>
          <el-table-column
            label="优先级"
            width="80"
            prop="priority"
            :formatter="priorityFormatter"
          ></el-table-column>
          <el-table-column
            label="状态"
            width="100"
            prop="itemStatus"
          ></el-table-column>
          <!-- <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>-->
        </el-table>
      </el-form-item>

      <el-divider></el-divider>

      <el-form-item label="计划明细">
        <el-row id="btnRow">
          <el-button @click="suggest" type="primary">建议计划</el-button>
          <el-button @click="toAddPlan" type="primary" id="addPlanBtn"
            >添加计划</el-button
          >
        </el-row>

        <el-table
          :data="form.plans"
          style="width: 100%"
          border
          show-summary
          :default-sort="{ prop: 'customer', order: 'descending' }"
        >
          <el-table-column
            prop="itemNo"
            label="订单项目编号"
            width="180"
          ></el-table-column>
          <el-table-column prop="cylinderNo" label="缸号"></el-table-column>
          <el-table-column label="纱支原料" prop="yarn"></el-table-column>
          <el-table-column label="颜色/色号">
            <template slot-scope="scope">
              <span>{{ scope.row.color }}</span>
              <span v-if="scope.row.color && scope.row.colorNo">/</span>
              <span>{{ scope.row.colorNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单(拆分)数量/投产数量/净重(KG)" width="250">
            <template slot-scope="scope">
              <span
                >{{ scope.row.planWeight }} / {{ scope.row.productWeight }} /
                {{ scope.row.netWeight }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="实际损耗%"
            :formatter="loseFormatter"
          ></el-table-column>
          <el-table-column prop="demand" label="参照缸号"></el-table-column>
          <el-table-column
            prop="tempLocation"
            label="暂存位置"
          ></el-table-column>
          <el-table-column prop="planStatus" label="计划状态"></el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <!-- <el-form-item>
        <el-button type="primary" @click="createPlan">提交计划</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>-->
    </el-form>

    <el-dialog
      v-dialogDrag
      title="订单项目计划"
      :visible.sync="planDialogVisible"
      :width="dialogWidth"
    >
      <el-form :model="orderPlanForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="纱支">
              <el-select
                v-model="orderPlanForm.yarn"
                placeholder="请选择纱支"
                filterable
                allow-create
                clearable
                style="width: 100%"
                @change="selectYarn"
              >
                <el-option
                  v-for="item in getYarnList"
                  :key="item.id"
                  :label="item.yarn"
                  :value="item"
                >
                  <span>{{ item.itemNo }} |</span>
                  <span>{{ item.yarn }} |</span>
                  <span v-if="item.color">{{ item.color }} |</span>
                  <span v-if="item.colorNo">{{ item.colorNo }} |</span>
                  <span v-if="item.demand">{{ item.demand }} |</span>
                  <span v-if="item.process">{{ item.process }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="缸号">
              <el-input v-model="orderPlanForm.cylinderNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="颜色">
              <el-input v-model="orderPlanForm.color"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="色号">
              <el-input v-model="orderPlanForm.colorNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参照缸号">
              <el-input v-model="orderPlanForm.demand"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider></el-divider>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="订单(拆分)数量(KG)">
              <el-input
                v-model="orderPlanForm.planWeight"
                type="number"
                step="0.01"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="损耗配比%">
              <el-input
                v-model="orderPlanForm.loss"
                type="number"
                min="0"
                max="100"
                @change="changeLoss"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="投入数量(KG)">
              <el-input
                v-model="orderPlanForm.productWeight"
                type="number"
                step="0.01"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="净重(KG)">
              <el-input
                v-model="orderPlanForm.netWeight"
                type="number"
                step="0.01"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="绞数/筒数">
              <el-input v-model="orderPlanForm.quantity"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="加工">
              <el-input v-model="orderPlanForm.process"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="暂存位置">
              <el-input v-model="orderPlanForm.tempLocation"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注">
              <el-input
                type="textarea"
                v-model="orderPlanForm.remark"
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="planDialogVisible = false">取 消</el-button>
        <el-button v-if="updateFlag" type="primary" @click="updatePlan"
          >更 新</el-button
        >
        <el-button v-else type="primary" @click="addPlan">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import PageHeader from "../components/PageHeader.vue";
// import OrderItemTable from "../components/OrderItemTable.vue";
export default {
  components: {
    PageHeader,
    // OrderItemTable
  },
  computed: {
    getYarnList: function () {
      console.log("加载项目");
      let yarnList = [];
      if (this.form.orderItems) {
        this.form.orderItems.forEach((element) => {
          yarnList.push({
            itemNo: element.itemNo,
            yarn: element.yarn,
            color: element.color,
            colorNo: element.colorNo,
            demand: element.demand,
            process: element.process,
            planWeight: element.itemQuantity,
            productWeight: element.productQuantity,
          });
          if (element.combine == "是") {
            yarnList.push({
              itemNo: element.itemNo,
              yarn: element.yarn,
              color: element.combineColor,
              colorNo: element.combineColorNo,
              demand: element.combineDemand,
              process: element.process,
              planWeight: element.itemQuantity / 2,
              productWeight: element.productQuantity / 2,
            });
          }
        });
      }
      return yarnList;
    },
  },
  data() {
    return {
      form: {},
      orderPlanForm: {},
      planDialogVisible: false,
      dialogWidth: "700px",
      formLabelWidth: "100px",
      updateFlag: false,
    };
  },
  methods: {
    cancel() {
      this.$router.back(-1);
    },
    queryOrderDetail(orderNo) {
      var url = "order/detail/" + orderNo;
      var self = this;
      this.$axios.get(url).then(function (response) {
        if (response.data.errorCode == "00000") {
          self.form = response.data.data;
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
    suggest() {
      console.log("建议计划");
    },
    toAddPlan() {
      this.orderPlanForm = {};
      this.updateFlag = false;
      this.planDialogVisible = true;
    },
    addPlan() {
      //保存计划
      var self = this;
      this.$axios
        .post("/orderPlan/create", self.orderPlanForm)
        .then(function (response) {
          if (response.data.errorCode == "00000") {
            self.$message({
              message: "创建成功",
              type: "success",
            });
            self.planDialogVisible = false;
            self.queryOrderDetail(self.$route.params.orderNo);
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    selectYarn(item) {
      console.log("选择胚纱");
      // this.orderPlanForm.itemNo = item.itemNo;
      // this.orderPlanForm.yarn = item.yarn;
      // this.orderPlanForm.color = item.color;
      // this.orderPlanForm.colorNo = item.colorNo;
      // this.orderPlanForm.demand = item.demand;
      // this.orderPlanForm.process = item.process;

      this.$set(this.orderPlanForm, "orderNo", this.form.orderNo);
      this.$set(this.orderPlanForm, "itemNo", item.itemNo);
      this.$set(this.orderPlanForm, "yarn", item.yarn);
      this.$set(this.orderPlanForm, "color", item.color);
      this.$set(this.orderPlanForm, "colorNo", item.colorNo);
      this.$set(this.orderPlanForm, "demand", item.demand);
      this.$set(this.orderPlanForm, "process", item.process);
      this.$set(this.orderPlanForm, "planWeight", item.planWeight);
      this.$set(this.orderPlanForm, "productWeight", item.productWeight);
    },
    changeLoss() {
      var pw =
        this.orderPlanForm.planWeight * (1 + this.orderPlanForm.loss / 100);
      this.$set(this.orderPlanForm, "productWeight", pw.toFixed(2));
    },
    priorityFormatter(row) {
      if (row.priority == "1") {
        return "正常";
      } else if (row.priority == "2") {
        return "重要";
      } else if (row.priority == "3") {
        return "紧急";
      }
    },
    handleDelete(index, row) {
      var self = this;
      this.$confirm("确定要删除缸号：" + row.cylinderNo + "的计划吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          self.$axios
            .delete("/orderPlan/remove/" + row.id)
            .then(function (response) {
              if (response.data.errorCode == "00000") {
                self.$message({
                  message: "删除成功",
                  type: "success",
                });
                self.queryOrderDetail(self.$route.params.orderNo);
              } else {
                self.$message.error(response.data.errorMsg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleEdit(index, row) {
      this.orderPlanForm = JSON.parse(JSON.stringify(row));
      this.updateFlag = true;
      this.planDialogVisible = true;
    },
    updatePlan() {
      var self = this;
      this.$axios
        .post("/orderPlan/update", self.orderPlanForm)
        .then(function (response) {
          if (response.data.errorCode == "00000") {
            self.$message({
              message: "创建成功",
              type: "success",
            });
            self.planDialogVisible = false;
            self.queryOrderDetail(self.$route.params.orderNo);
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
    },
    loseFormatter(row) {
      if (row.productWeight && row.netWeight) {
        return (
          (
            ((row.productWeight - row.netWeight) * 100) /
            row.productWeight
          ).toFixed(2) + "%"
        );
      }
    },
    toDelivery(){
      this.$router.push("/delivery/");
    },
    createDelivery(){
      this.$router.push("/delivery/create/");
    },
  },
  mounted() {
    const orderNo = this.$route.params.orderNo;
    this.queryOrderDetail(orderNo);
  },
};
</script>

<style scoped>
.el-form {
  --width: 600px;
  margin-top: 50px;
}
#btnRow {
  margin-bottom: 10px;
}
.rightBtn {
  float: right;
  margin-top: -25px;
}
</style>